import React from "react";
import { months } from "../../../../../../Utils/months";
import { RowNames } from "../../../Utils/TableComponents";
import SKIMMonth from "./SKIMMonth";

export default function SKIMTable() {
    const rowNames = [
        'Entradas MP a producción',
        '(-) SKIM para sólidos',
        '(+) Gtos. Fabricación del mes',
        '(=) Producción del mes',
        '(+) Prod. Term. Mes anterior',
        '(-) Skim reclasificado a latex por maquila',
        '(=) Prod. Term. Disponible',
        '(-) Costo Vta. Del Mes',
        '(=) Prod. Termin. Final'
    ];

    return (
        <div className="report__table-container">
            <h6>SKIM</h6>
            <div className="report__month-tables">
                <RowNames rowNames={rowNames} totalRows={[3, 6, 8]} />
                {months.map((month, index) => {
                    return (<SKIMMonth key={index} month={month} monthIndex={index} />)
                })}
            </div>
        </div>
    );
}
